var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_15x23_flag_photo",
    "data-name": "15x23 flag photo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 23,
    height: 15,
    viewBox: "0 0 23 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4601",
    "data-name": "Rectangle 4601",
    width: 23,
    height: 15,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_92",
    "data-name": "Mask Group 92",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "turkey",
    transform: "translate(0.053 -3.947)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16019",
    "data-name": "Path 16019",
    d: "M21.18,3.947H1.715A1.715,1.715,0,0,0,0,5.662V17.233a1.715,1.715,0,0,0,1.715,1.715H21.18a1.715,1.715,0,0,0,1.715-1.715V5.662A1.715,1.715,0,0,0,21.18,3.947Z",
    fill: "#ff4b55"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4682",
    "data-name": "Group 4682"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16020",
    "data-name": "Path 16020",
    d: "M11.334,10.095l.619.809.966-.323a.059.059,0,0,1,.068.09l-.579.839.606.819a.059.059,0,0,1-.065.092l-.976-.291-.592.829a.059.059,0,0,1-.108-.033l-.025-1.018-.972-.306a.059.059,0,0,1,0-.112l.961-.338-.009-1.019A.059.059,0,0,1,11.334,10.095Z",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16021",
    "data-name": "Path 16021",
    d: "M7.913,14.607a3.16,3.16,0,0,1,0-6.319,3.1,3.1,0,0,1,1.746.537.076.076,0,0,0,.1-.115A3.915,3.915,0,0,0,6.789,7.5a3.947,3.947,0,0,0,.137,7.892,3.916,3.916,0,0,0,2.835-1.212.076.076,0,0,0-.1-.113A3.1,3.1,0,0,1,7.913,14.607Z",
    fill: "#f5f5f5"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.a50c094e8007a1dfed31d695db1ac34a.svg";
export { ForwardRef as ReactComponent };